export default class agaMain{
    constructor(context){
        this.context = context;
        this.serverURL = "http://assogeolaube.fr/ouvrages/";
        this.data = null;
        this.filteredBulletins = null;  
        this.filters = [];  
        this.freeFilter = "";
    }

    init(){
        this.loadJSON('data/data.json',(data)=>{
            this.data = JSON.parse(data);
            this.filteredBulletins = this.data.bulletins
            this.data.categories.forEach(() => {
                this.filters.push(null);
            });
        });
    }

    filterFree(){
        if(this.freeFilter == ""){
            this.filteredBulletins = this.data.bulletins;
            return;
        }
            
        var array = [];
        this.data.bulletins.forEach(bulletin =>{
            var mainFound = false;
            var newBull = JSON.parse(JSON.stringify(bulletin));
            newBull.subjects = [];
            bulletin.subjects.forEach(subject =>{
                var found = false;
                this.data.categories.forEach(cat=>{
                    var filters = this.freeFilter.split(' ');
                    filters.forEach(filter=>{
                        
                        filter = filter.toLocaleLowerCase();
                        var readable = cat.values.find(x=>x.name.toLocaleLowerCase() == filter)
                        if(readable != undefined && subject[cat.name].includes(readable.id)){
                            mainFound = true;
                            found = true
                        }
                    });
                })
                if(found){
                    newBull.subjects.push(subject);
                }
            })
            if(mainFound)
                array.push(newBull);
        });

        this.filteredBulletins = array;
    }
    

    filterBulletins(){
        var nofilter = true;
        for(var i=0;i< this.filters.length; i++)
        {
            if(this.filters[i] != null && this.filters[i] != "null")
                nofilter = false;
        }

        if (nofilter){
            this.filteredBulletins = this.data.bulletins;
            return;
        }

        this.filteredBulletins = []

        this.data.bulletins.forEach(bulletin =>{
            var mainFound = false;
            var newBull = JSON.parse(JSON.stringify(bulletin));
            newBull.subjects = [];            
            bulletin.subjects.forEach(subject =>{
                var found = 0;
                var count = 0;
                var newSubject = JSON.parse(JSON.stringify(subject));
                newSubject.matching = [];
                for(var i=0;i< this.filters.length; i++)
                {
                    if(this.filters[i]!=null && this.filters[i]!= "null"){
                        count++;
                        console.log("category", this.data.categories[i].name)
                        if(subject[this.data.categories[i].name].includes(this.filters[i].id)){
                            found++;
                            //var entry
                            newSubject.matching.push(this.filters[i].name)
                        }
                    }
                }
                console.log("filters", count)
                if(found==count){
                    newBull.subjects.push(newSubject);
                    mainFound = true;
                }
            });
            if(mainFound)
                this.filteredBulletins.push(newBull);
        });
    }

    log(data){
        console.log("log",data)
    }

    loadJSON(path,callback) {   
        var xobj = new XMLHttpRequest();
            xobj.overrideMimeType("application/json");
        xobj.open('GET', path, true);
        xobj.onreadystatechange = function () {
              if (xobj.readyState == 4 && xobj.status == "200") {
                // Required use of an anonymous callback as .open will NOT return a value but simply returns undefined in asynchronous mode
                callback(xobj.responseText);
              }
        };
        xobj.send(null);  
    }
}